export default {
  // Default variant - Standard styling without admin prefix
  default: {
    // Container
    root: "space-y-6",
    container: "space-y-6",
    section: "",

    // Grid system
    grid: "grid gap-4",
    grid_cell: "bg-paper border border-bordered rounded-lg p-4",

    // Grid column utilities
    grid_cols_1: "grid-cols-1",
    grid_cols_2: "grid-cols-1 md:grid-cols-2",
    grid_cols_3: "grid-cols-1 md:grid-cols-3",
    grid_cols_4: "grid-cols-1 md:grid-cols-2 lg:grid-cols-4",
    col_span_1: "col-span-1",
    col_span_2: "col-span-1 md:col-span-2",
    col_span_3: "col-span-1 md:col-span-3",
    col_span_4: "col-span-1 md:col-span-4",

    // Dark header styles
    dark_header_wrapper: "bg-paper rounded-xl overflow-hidden shadow-sm",
    dark_header: "bg-text p-6 md:p-8",
    dark_header_grid: "grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8",
    dark_header_section: "",
    dark_header_divider:
      "border-b md:border-b-0 md:border-r border-neutral_3 pb-6 md:pb-0 md:pr-8",
    dark_header_children: "p-6 bg-canvas",
    dark_header_label: "text-neutral_2",
    dark_header_value: "text-white",

    // Stat cell styles
    stat_label: "text-text_secondary text-sm",
    stat_value_wrapper: "flex items-baseline mt-2",
    stat_value: "font-light text-text text-2xl",
    stat_suffix: "ml-3 font-normal text-text_secondary",

    // Medium stat cell styles
    stat_medium_label:
      "uppercase tracking-wider mb-2 text-text_secondary text-xs",
    stat_medium_value_wrapper: "flex items-baseline",
    stat_medium_value: "font-bold text-text text-xl",
    stat_medium_suffix: "ml-2 text-text_secondary",

    // Text cell styles
    text_label: "uppercase tracking-wider mb-2 text-text_secondary text-xs",
    text_value: "font-semibold text-text",

    // Code cell styles
    code_label: "uppercase tracking-wider mb-2 text-text_secondary text-xs",
    code_value: "text-text font-mono font-medium break-all",

    // Custom cell styles
    custom_text: "text-text",

    // Badge cell styles
    badge_container: "bg-neutral_3 border border-neutral_2 rounded-lg p-4",
    badge_label: "text-neutral_1 text-xs mb-1",
    badge_value: "text-primary font-mono font-medium text-base",
    badge_tag:
      "mt-2 bg-neutral_2/50 text-neutral_1 px-2 py-1 rounded text-xs font-medium inline-block",

    // Highlight cell styles
    highlight_default: {
      container: "bg-success/10 border border-success/20 rounded-lg p-4",
      content: "flex items-center space-x-3",
      icon_wrapper:
        "w-10 h-10 bg-success/20 rounded-full flex items-center justify-center",
      title: "text-success font-medium",
      subtitle: "text-text_secondary",
    },

    // Dynamic highlight styles function
    getHighlightStyles: (color) => {
      const colorMap = {
        success: {
          container: "bg-success/10 border border-success/20 rounded-lg p-4",
          content: "flex items-center space-x-3",
          icon_wrapper:
            "w-10 h-10 bg-success/20 rounded-full flex items-center justify-center",
          title: "text-success font-medium",
          subtitle: "text-text_secondary",
        },
        error: {
          container: "bg-error/10 border border-error/20 rounded-lg p-4",
          content: "flex items-center space-x-3",
          icon_wrapper:
            "w-10 h-10 bg-error/20 rounded-full flex items-center justify-center",
          title: "text-error font-medium",
          subtitle: "text-text_secondary",
        },
        warning: {
          container: "bg-warning/10 border border-warning/20 rounded-lg p-4",
          content: "flex items-center space-x-3",
          icon_wrapper:
            "w-10 h-10 bg-warning/20 rounded-full flex items-center justify-center",
          title: "text-warning font-medium",
          subtitle: "text-text_secondary",
        },
        info: {
          container: "bg-info/10 border border-info/20 rounded-lg p-4",
          content: "flex items-center space-x-3",
          icon_wrapper:
            "w-10 h-10 bg-info/20 rounded-full flex items-center justify-center",
          title: "text-info font-medium",
          subtitle: "text-text_secondary",
        },
        primary: {
          container: "bg-primary/10 border border-primary/20 rounded-lg p-4",
          content: "flex items-center space-x-3",
          icon_wrapper:
            "w-10 h-10 bg-primary/20 rounded-full flex items-center justify-center",
          title: "text-primary font-medium",
          subtitle: "text-text_secondary",
        },
      }

      return colorMap[color] || colorMap.success
    },

    // Cell style getters
    getCellStyle: (className) => className || "",
    getGridStyle: (cols) => `grid-cols-${cols}`,
  },

  // Admin variant - Admin panel styling
  admin: {
    // Container
    root: "space-y-6",
    container: "space-y-6",
    section: "",

    // Grid system
    grid: "grid gap-4",
    grid_cell: "bg-admin_paper border border-admin_bordered rounded-lg p-4",

    // Grid column utilities
    grid_cols_1: "grid-cols-1",
    grid_cols_2: "grid-cols-1 md:grid-cols-2",
    grid_cols_3: "grid-cols-1 md:grid-cols-3",
    grid_cols_4: "grid-cols-1 md:grid-cols-2 lg:grid-cols-4",
    col_span_1: "col-span-1",
    col_span_2: "col-span-1 md:col-span-2",
    col_span_3: "col-span-1 md:col-span-3",
    col_span_4: "col-span-1 md:col-span-4",

    // Dark header styles
    dark_header_wrapper: "bg-admin_paper rounded-xl overflow-hidden shadow-sm",
    dark_header: "bg-admin_text p-6 md:p-8",
    dark_header_grid: "grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8",
    dark_header_section: "",
    dark_header_divider:
      "border-b md:border-b-0 md:border-r border-admin_neutral_3 pb-6 md:pb-0 md:pr-8",
    dark_header_children: "p-6 bg-admin_canvas",
    dark_header_label: "text-admin_neutral_2",
    dark_header_value: "text-white",

    // Stat cell styles
    stat_label: "text-admin_text_secondary text-sm",
    stat_value_wrapper: "flex items-baseline mt-2",
    stat_value: "font-light text-admin_text text-2xl",
    stat_suffix: "ml-3 font-normal text-admin_text_secondary",

    // Medium stat cell styles
    stat_medium_label:
      "uppercase tracking-wider mb-2 text-admin_text_secondary text-xs",
    stat_medium_value_wrapper: "flex items-baseline",
    stat_medium_value: "font-bold text-admin_text text-xl",
    stat_medium_suffix: "ml-2 text-admin_text_secondary",

    // Text cell styles
    text_label:
      "uppercase tracking-wider mb-2 text-admin_text_secondary text-xs",
    text_value: "font-semibold text-admin_text",

    // Code cell styles
    code_label:
      "uppercase tracking-wider mb-2 text-admin_text_secondary text-xs",
    code_value: "text-admin_text font-mono font-medium break-all",

    // Custom cell styles
    custom_text: "text-admin_text",

    // Badge cell styles
    badge_container:
      "bg-admin_canvas border border-admin_neutral_2 rounded-lg p-4",
    badge_label: "text-admin_text text-xs mb-1",
    badge_value: "text-admin_primary font-mono font-medium text-base",
    badge_tag:
      "mt-2 bg-admin_neutral_2 text-admin_text px-2 py-1 rounded text-xs font-medium inline-block",

    // Highlight cell styles
    highlight_default: {
      container:
        "bg-admin_success/10 border border-admin_success/20 rounded-lg p-4",
      content: "flex items-center space-x-3",
      icon_wrapper:
        "w-10 h-10 bg-admin_success/20 rounded-full flex items-center justify-center",
      title: "text-admin_success font-medium",
      subtitle: "text-admin_text_secondary",
    },

    // Dynamic highlight styles function
    getHighlightStyles: (color) => {
      const colorMap = {
        admin_success: {
          container:
            "bg-admin_success/10 border border-admin_success/20 rounded-lg p-4",
          content: "flex items-center space-x-3",
          icon_wrapper:
            "w-10 h-10 bg-admin_success/20 rounded-full flex items-center justify-center",
          title: "text-admin_success font-medium",
          subtitle: "text-admin_text_secondary",
        },
        admin_error: {
          container:
            "bg-admin_error/10 border border-admin_error/20 rounded-lg p-4",
          content: "flex items-center space-x-3",
          icon_wrapper:
            "w-10 h-10 bg-admin_error/20 rounded-full flex items-center justify-center",
          title: "text-admin_error font-medium",
          subtitle: "text-admin_text_secondary",
        },
        admin_warning: {
          container:
            "bg-admin_warning/10 border border-admin_warning/20 rounded-lg p-4",
          content: "flex items-center space-x-3",
          icon_wrapper:
            "w-10 h-10 bg-admin_warning/20 rounded-full flex items-center justify-center",
          title: "text-admin_warning font-medium",
          subtitle: "text-admin_text_secondary",
        },
        admin_info: {
          container:
            "bg-admin_info/10 border border-admin_info/20 rounded-lg p-4",
          content: "flex items-center space-x-3",
          icon_wrapper:
            "w-10 h-10 bg-admin_info/20 rounded-full flex items-center justify-center",
          title: "text-admin_info font-medium",
          subtitle: "text-admin_text_secondary",
        },
        admin_primary: {
          container:
            "bg-admin_primary/10 border border-admin_primary/20 rounded-lg p-4",
          content: "flex items-center space-x-3",
          icon_wrapper:
            "w-10 h-10 bg-admin_primary/20 rounded-full flex items-center justify-center",
          title: "text-admin_primary font-medium",
          subtitle: "text-admin_text_secondary",
        },
      }

      return colorMap[color] || colorMap.admin_success
    },

    // Cell style getters
    getCellStyle: (className) => className || "",
    getGridStyle: (cols) => `grid-cols-${cols}`,
  },

  // Candy variant - Colorful and playful styling
  candy: {
    // Container
    root: "space-y-6",
    container: "space-y-6",
    section: "",

    // Grid system
    grid: "grid gap-4",
    grid_cell:
      "bg-gradient-to-br from-pink-50 to-purple-50 border-2 border-purple-200 rounded-xl p-4 shadow-sm hover:shadow-md transition-shadow",

    // Grid column utilities
    grid_cols_1: "grid-cols-1",
    grid_cols_2: "grid-cols-1 md:grid-cols-2",
    grid_cols_3: "grid-cols-1 md:grid-cols-3",
    grid_cols_4: "grid-cols-1 md:grid-cols-2 lg:grid-cols-4",
    col_span_1: "col-span-1",
    col_span_2: "col-span-1 md:col-span-2",
    col_span_3: "col-span-1 md:col-span-3",
    col_span_4: "col-span-1 md:col-span-4",

    // Dark header styles (gradient version)
    dark_header_wrapper: "bg-white rounded-2xl overflow-hidden shadow-lg",
    dark_header:
      "bg-gradient-to-r from-purple-600 via-pink-600 to-red-600 p-6 md:p-8",
    dark_header_grid: "grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8",
    dark_header_section: "",
    dark_header_divider:
      "border-b md:border-b-0 md:border-r border-white/30 pb-6 md:pb-0 md:pr-8",
    dark_header_children: "p-6 bg-gradient-to-br from-purple-50 to-pink-50",
    dark_header_label: "text-white/80 font-medium",
    dark_header_value: "text-white font-bold drop-shadow-lg",

    // Stat cell styles
    stat_label: "text-purple-700 text-sm font-medium",
    stat_value_wrapper: "flex items-baseline mt-2",
    stat_value:
      "font-bold text-transparent bg-clip-text bg-gradient-to-r from-purple-600 to-pink-600 text-3xl",
    stat_suffix: "ml-3 font-medium text-purple-600",

    // Medium stat cell styles
    stat_medium_label:
      "uppercase tracking-wider mb-2 text-pink-600 text-xs font-bold",
    stat_medium_value_wrapper: "flex items-baseline",
    stat_medium_value: "font-black text-purple-700 text-2xl",
    stat_medium_suffix: "ml-2 text-pink-600 font-medium",

    // Text cell styles
    text_label:
      "uppercase tracking-wider mb-2 text-purple-600 text-xs font-bold",
    text_value: "font-bold text-purple-800",

    // Code cell styles
    code_label: "uppercase tracking-wider mb-2 text-pink-600 text-xs font-bold",
    code_value:
      "text-purple-700 font-mono font-bold break-all bg-white/50 px-2 py-1 rounded",

    // Custom cell styles
    custom_text: "text-purple-800 font-medium",

    // Badge cell styles
    badge_container:
      "bg-gradient-to-r from-yellow-400 to-orange-500 rounded-xl p-4 shadow-md",
    badge_label: "text-white/90 text-xs mb-1 font-medium",
    badge_value: "text-white font-mono font-bold text-lg drop-shadow",
    badge_tag:
      "mt-2 bg-white/30 text-white px-3 py-1 rounded-full text-xs font-bold inline-block backdrop-blur-sm",

    // Highlight cell styles
    highlight_default: {
      container:
        "bg-gradient-to-br from-green-100 to-emerald-100 border-2 border-green-400 rounded-xl p-4 shadow-md",
      content: "flex items-center space-x-3",
      icon_wrapper:
        "w-12 h-12 bg-gradient-to-br from-green-400 to-emerald-500 rounded-full flex items-center justify-center shadow-lg",
      title: "text-green-700 font-bold text-lg",
      subtitle: "text-green-600",
    },

    // Dynamic highlight styles function
    getHighlightStyles: (color) => {
      const colorMap = {
        success: {
          container:
            "bg-gradient-to-br from-green-100 to-emerald-100 border-2 border-green-400 rounded-xl p-4 shadow-md",
          content: "flex items-center space-x-3",
          icon_wrapper:
            "w-12 h-12 bg-gradient-to-br from-green-400 to-emerald-500 rounded-full flex items-center justify-center shadow-lg",
          title: "text-green-700 font-bold text-lg",
          subtitle: "text-green-600",
        },
        error: {
          container:
            "bg-gradient-to-br from-red-100 to-rose-100 border-2 border-red-400 rounded-xl p-4 shadow-md",
          content: "flex items-center space-x-3",
          icon_wrapper:
            "w-12 h-12 bg-gradient-to-br from-red-400 to-rose-500 rounded-full flex items-center justify-center shadow-lg",
          title: "text-red-700 font-bold text-lg",
          subtitle: "text-red-600",
        },
        warning: {
          container:
            "bg-gradient-to-br from-yellow-100 to-amber-100 border-2 border-yellow-400 rounded-xl p-4 shadow-md",
          content: "flex items-center space-x-3",
          icon_wrapper:
            "w-12 h-12 bg-gradient-to-br from-yellow-400 to-amber-500 rounded-full flex items-center justify-center shadow-lg",
          title: "text-yellow-700 font-bold text-lg",
          subtitle: "text-yellow-600",
        },
        info: {
          container:
            "bg-gradient-to-br from-blue-100 to-indigo-100 border-2 border-blue-400 rounded-xl p-4 shadow-md",
          content: "flex items-center space-x-3",
          icon_wrapper:
            "w-12 h-12 bg-gradient-to-br from-blue-400 to-indigo-500 rounded-full flex items-center justify-center shadow-lg",
          title: "text-blue-700 font-bold text-lg",
          subtitle: "text-blue-600",
        },
        primary: {
          container:
            "bg-gradient-to-br from-purple-100 to-pink-100 border-2 border-purple-400 rounded-xl p-4 shadow-md",
          content: "flex items-center space-x-3",
          icon_wrapper:
            "w-12 h-12 bg-gradient-to-br from-purple-400 to-pink-500 rounded-full flex items-center justify-center shadow-lg",
          title: "text-purple-700 font-bold text-lg",
          subtitle: "text-purple-600",
        },
      }

      return colorMap[color] || colorMap.primary
    },

    // Cell style getters
    getCellStyle: (className) => className || "",
    getGridStyle: (cols) => `grid-cols-${cols}`,
  },
}
